/** Facets / directories for catalog root — no products download. */
export function loadCatalogFacets({
  getCategories,
  getSections,
  getVendors,
  getSituations,
}) {
  return Promise.all([
    getCategories(),
    getSections().catch(() => []),
    getVendors({ view: 'catalog' }).catch(() => []),
    getSituations().catch(() => []),
  ]);
}

/**
 * One page of catalog products (server filters + limit/offset).
 * @returns {Promise<{ items: Array, total: number, limit: number, offset: number }>}
 */
export function loadCatalogProductsPage(getProducts, params = {}) {
  const {
    limit = 12,
    offset = 0,
    vendor_slug,
    category,
    section_id,
    section_slug,
    situation_id,
    q,
  } = params;

  return getProducts({
    view: 'catalog',
    limit,
    offset,
    vendor_slug,
    category,
    section_id,
    section_slug,
    situation_id,
    q,
  });
}

/**
 * @deprecated Prefer loadCatalogFacets + loadCatalogProductsPage.
 * Kept for transitional callers; still requests a catalog page (limit=12), not the full list.
 */
export function loadCatalogGrid({
  getProducts,
  getCategories,
  getSections,
  getVendors,
  getSituations,
  includeProducts = true,
  productsParams = { limit: 12, offset: 0 },
}) {
  const facets = loadCatalogFacets({
    getCategories,
    getSections,
    getVendors,
    getSituations,
  });

  if (!includeProducts) {
    return facets.then(([categories, sections, vendors, situations]) => [
      [],
      categories,
      sections,
      vendors,
      situations,
    ]);
  }

  return Promise.all([
    loadCatalogProductsPage(getProducts, productsParams).then((page) =>
      Array.isArray(page) ? page : page?.items || [],
    ),
    ...[
      getCategories(),
      getSections().catch(() => []),
      getVendors({ view: 'catalog' }).catch(() => []),
      getSituations().catch(() => []),
    ],
  ]);
}
